import React from 'react';

import styles from './AuthorizedContainer.module.scss';

const AuthorizedContainer = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default AuthorizedContainer;
